import React from 'react'
import {createIcon} from '@chakra-ui/react'

import {colors} from '../theme/foundations/colors'

const viewBox = '0 0 22 22'

const path = ({circle, exclamation}) => (
  <>
    <circle
      cx="11"
      cy="11"
      r="10"
      stroke={circle.stroke}
      strokeWidth="2"
      fill={circle.fill}
    />
    <rect
      x="12"
      y="5"
      width="8"
      height="2"
      transform="rotate(90 12 5)"
      fill={exclamation.fill}
    />
    <rect
      x="12"
      y="15"
      width="2"
      height="2"
      transform="rotate(90 12 15)"
      fill={exclamation.fill}
    />
  </>
)

export const AttentionIcon = createIcon({
  displayName: 'AttentionIcon',
  viewBox,
  path: path({
    circle: {
      stroke: 'currentColor',
      fill: 'transparent',
    },
    exclamation: {
      fill: 'currentColor',
    },
  }),
})

export const AttentionIconWarning = createIcon({
  displayName: 'AttentionIconWarning',
  viewBox,
  path: path({
    circle: {
      stroke: colors.mld.warning[700],
      fill: colors.mld.warning[700],
    },
    exclamation: {
      fill: 'currentColor',
    },
  }),
})

export const AttentionIconAlert = createIcon({
  displayName: 'AttentionIconAlert',
  viewBox,
  path: path({
    circle: {
      stroke: colors.mld.alert[700],
      fill: colors.mld.alert[700],
    },
    exclamation: {
      fill: 'currentColor',
    },
  }),
})
